import { Router, ActivatedRoute } from '@angular/router';
import { Injectable } from '@angular/core';
// import { CookieService } from 'ngx-cookie-service';
import { CookieService } from '../../data-worker/cookie.service';
import Auth from '@aws-amplify/auth';
import { Attribute } from '@angular/compiler';

@Injectable()
export class AuthService {
  token: string;
  AUTH = ''

  constructor(
    private cookieService: CookieService,
    private router: Router,
    private route: ActivatedRoute,
  ) {}

  signIn(email: string, password: string, callback) { 
    //if (this.checkAuth()){
    //  
    //}
    const user = Auth.signIn(email, password);
  console.log(user);
    user.then(
      function(result){
        //this.cookieService.set('auth', null);
        // alert('inside singin');
        //alert(JSON.stringify(result));
        callback(result);
        //this.router.navigate(['/dashboard/dashboard1'], { relativeTo: this.route.parent });
      }, 
      function(err){
        
        // alert(JSON.stringify(err.message));
        callback(err);
        if (err.code === 'UserNotConfirmedException') {
          // alert("Please confirm your email address first!");
        } else if (err.code === 'PasswordResetRequiredException') {
          // alert("Please change your password before login!");
        } else if (err.code === 'NotAuthorizedException') {
          // alert("Incorrect username or password!");
        } else if (err.code === 'UserNotFoundException') {
          // alert("No user found. Please register first!");
        } else {
          // alert("Error logging in. Try again!");
        }
      }
    );
    
    
  }

  signUp(username, email, password, myUserType:string, myClientID:string, myEUCID:string) {
  console.log(password)
    let user: any;
    if(myUserType == '1' || myUserType == '4'){ 
      user = Auth.signUp({
        username: username, 
        password: password,
        attributes: {
          'email':email,
          'custom:usertype': myUserType,
          //'custom:parent_client_id': myClientID,
          //'custom:parent_euc_id': myEUCID,
        }
      });
    }

    if(myUserType == '2'){ 
      user = Auth.signUp({
        username: username, 
        password: password,
        attributes: {
          'email':email,
          'custom:usertype': myUserType,
          'custom:parent_client_id': myClientID,
          //'custom:parent_euc_id': myEUCID,
        }
      });
    }

    if(myUserType == '3'){ 
      user = Auth.signUp({
        username: username, 
        password: password,
        attributes: {
          'email':email,
          'custom:usertype': myUserType,
          'custom:parent_client_id': myClientID,
          'custom:parent_euc_id': myEUCID,
        }
      });
    }

  console.log(user);
   console.log('signup')
    user.then(
      function(result){
       console.log(result)
        alert(JSON.stringify(result))
        //Redirect to a new thank you page
        //this.router.navigate(['/pages/login'], { relativeTo: this.route.parent });
      }, 
      function(err){
        alert(JSON.stringify(err.message));
        if (err.code === 'UserNotConfirmedException') {
          // The error happens if the user didn't finish the confirmation step when signing up
          // In this case you need to resend the code and confirm the user
          // About how to resend the code and confirm the user, please check the signUp part
        } else if (err.code === 'PasswordResetRequiredException') {
            // The error happens when the password is reset in the Cognito console
            // In this case you need to call forgotPassword to reset the password
            // Please check the Forgot Password part.
        } else if (err.code === 'NotAuthorizedException') {
            // The error happens when the incorrect password is provided
        } else if (err.code === 'UserNotFoundException') {
            // The error happens when the supplied username/email does not exist in the Cognito user pool
        } else {
            
        }
      }
    )
  }

  checkAuth() {
    this.AUTH = this.cookieService.get('auth');
   console.log(this.AUTH, "this.AUTH");

    //   if(this.AUTH && this.AUTH == 'true'){
    if (this.cookieService.get('auth') == 'true'){
      Auth.currentAuthenticatedUser({
        bypassCache: false  // Optional, By default is false. If set to true, this call will send a request to Cognito to get the latest user data
        }).then(user =>console.log(user))
        .catch(err =>
          console.log(err)
          );  
      return true;}
    else {
     console.log("AUTH is FALSE");
      this.cookieService.set('auth', null);
      this.cookieService.set('deveuis', null);
      return false;
      this.router.navigate(['/pages/login'], { relativeTo: this.route.parent });
    }
  }

  logout() {   
    this.token = null;
    // this.cookieService.set( 'auth', 'false' );
    
  }

  getToken() {    
    return this.token;
  }

  isAuthenticated() {
    // here you can check if user is authenticated or not through his token 
    return true;
  }

  isLoggedIn(){
    Auth.currentAuthenticatedUser({
      bypassCache: false  // Optional, By default is false. If set to true, this call will send a request to Cognito to get the latest user data
  }).then(user =>console.log(user))
  .catch(err =>console.log(err));
  }

  forgotPasswordCode(username){
    Auth.forgotPassword(username)
    .then(data =>console.log(data))
    .catch(err =>console.log(err));
  }

  passwordReset(username, code, new_password){
    Auth.forgotPasswordSubmit(username, code, new_password)
    .then(data =>console.log(data))
    .catch(err =>console.log(err));
  }
}



// WEBPACK FOOTER //
// ./src/app/shared/auth/auth.service.ts